<script setup>
import CFRoundedButton from '@/ui/RoundedButton/CFRoundedButton.vue';
</script>

<template>
    <CFRoundedButton
        icon="arrow-left"
        color="secondary"
    />
</template>
